import { OnOffOption } from '../../../../_types';
import { verticalOptimizationCriterion } from '../../../../searchCriteria';

import { QuickSearchFilter } from '@cast/shared-search-ui';

const labelMap: Record<OnOffOption, string> = {
  [OnOffOption.ON]: 'On',
  [OnOffOption.OFF]: 'Off',
};

const verticalOptimizationOptions = Object.values(OnOffOption).map(
  (option) => ({
    title: labelMap[option],
    value: option,
  })
);

export const VerticalOptimizationQuickSearch = () => {
  return (
    <QuickSearchFilter
      options={verticalOptimizationOptions}
      criterion={verticalOptimizationCriterion}
      multiple
    />
  );
};
